var render = function render(){var _vm=this,_c=_vm._self._c;return (
        ![
            'createSimpleViewExperienceV3',
            'editSimpleViewExperienceV3',
            'createTreatmentV3',
            'editTreatmentV3',
            'createViewExperienceV3',
            'editViewExperienceV3',
            'editPackageV3',
            'createPackageV3',
            'indexViewProductCategoryV3',
            'indexViewProductBrandV3',
            'indexViewProductSupplierV3',
            'indexViewProductV3',
            'indexViewFoodV3',
            'createViewFoodV3',
            'editViewFoodV3',
            'createProductV3',
            'editProductV3',
            'getCustomersBOV3',
            'adminPlanning',
            'createSerieV3',
            'editSerieV3',
        ].includes(_vm.currentRoute)
    )?_c('header',{staticClass:"sticky top-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm transition-all duration-300",style:({ paddingLeft: _vm.normalizeSize(55), paddingRight: _vm.normalizeSize(55) }),attrs:{"id":"page-header"}},[_c('div',{staticClass:"d-flex flex-row align-items-center",style:({
            marginTop: '10px',
            marginBottom: _vm.normalizeSize(20, true),
            paddingTop: '10px',
        })},[_c('h4',{staticClass:"ppv2-text-black poppinsRegular uppercaseFirstLetter my-0 title-header",style:({ fontSize: _vm.normalizeFontSize(26) })},[_vm._v("\n            "+_vm._s(_vm.$t(_vm.currentIcon.title))+"\n        ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }